export default __webpack_public_path__ + "static/media/imm-fornitori.04db19b2.png";